import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import { AppLayout } from './components/AppLayout';
import { SplashPage } from './pages/SplashPage';
import { InquirePage } from './pages/InquirePage';
import { LoginPage } from './pages/LoginPage';
import { CalendarPage } from './pages/CalendarPage';
import { InquiriesPage } from './pages/InquiriesPage';
import { ClientsPage } from './pages/ClientsPage';
import { ClassesPage } from './pages/ClassesPage';
import { ClassDetailPage } from './pages/ClassDetailPage';
import { ClassTypesPage } from './pages/ClassTypesPage';
import { InstructorsPage } from './pages/InstructorsPage';
import { SettingsPage } from './pages/SettingsPage';

export function App() {
  return (
    <Routes>
      {/* Public marketing site */}
      <Route path="/" element={<SplashPage />} />
      <Route path="/inquire" element={<InquirePage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Staff scheduler (behind login) */}
      <Route
        path="/app"
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<CalendarPage />} />
        <Route path="inquiries" element={<InquiriesPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="classes" element={<ClassesPage />} />
        <Route path="classes/:id" element={<ClassDetailPage />} />
        <Route path="class-types" element={<ClassTypesPage />} />
        <Route path="instructors" element={<InstructorsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
